import i18n from '@/i18n';

/** 결제 방법 */
export enum PaymentMethod {
  /** 현금 */
  Cash = 'CASH',
  /** 카드 */
  Card = 'CARD',
  /** 간편 결제 */
  Easy = 'EASY',
  /** 포인트 */
  Point = 'POINT',
}

export const PaymentMethodTexts: Record<PaymentMethod, string> = {
  [PaymentMethod.Cash]: i18n.global.t('button.pay_cash'),
  [PaymentMethod.Card]: i18n.global.t('button.pay_card'),
  [PaymentMethod.Easy]: i18n.global.t('button.pay_easy'),
  [PaymentMethod.Point]: i18n.global.t('button.pay_point'),
};
